<template>
  <div
    class="overlay_tray"
    v-if="openPercentage > 0"
    v-touch:moving="touchMoveHandler"
    v-touch:start="touchStartHandler"
    v-touch:end="touchEndHandler"
  >
    <div @click="close" class="overlay_tray__overlay"></div>
    <div class="overlay_tray__content" :style="trayStyle">
      <div class="overlay_tray__control">
        <div class="overlay_tray__touch_indication"></div>
      </div>
      <div class="overlay_tray__slot" ref="slotHolder" :style="contentStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import animateXtoY from "../../helpers/animationHelper";

export default {
  name: "OverlayTray",
  props: {
    openPercentage: {
      type: Number,
      required: true,
      validator: (value) => value <= 1 && value >= 0,
      touchStartY: null,
      dragging: false,
    },
  },
  data() {
    return {
      contentStyle: "overflow: scroll",
    };
  },
  computed: {
    trayStyle() {
      const top = window.innerHeight * 0.8 * (1 - this.openPercentage);
      return {
        transform: `translateY(${top}px)`,
      };
    },
  },
  methods: {
    touchStartHandler(event) {
      if (this.$refs.slotHolder.scrollTop > 0) return;
      this.dragging = true;
      this.touchStartY = event.clientY || event.changedTouches[0].clientY;
    },
    touchMoveHandler(event) {
      if (this.$refs.slotHolder.scrollTop > 0 || !this.dragging) return;
      const clientY = event.clientY || event.changedTouches[0].clientY;
      const delta = clientY - this.touchStartY;
      let percentage = delta / (window.innerHeight * 0.8);
      if (percentage > 1) percentage = 1;
      if (percentage < 0) percentage = 0;
      this.$emit("openPercentageChangeRequest", { percentage: 1 - percentage });
    },
    touchEndHandler(e) {
      this.dragging = false;
      this.contentStyle = "overflow: scroll";
      if (this.openPercentage < 0.7 || e.target.nodeName === "A") {
        this.close();
      } else {
        this.open();
      }
    },
    close() {
      animateXtoY({
        x: this.openPercentage,
        y: 0,
        time: 200,
        executable: ({ setTo }) => {
          this.$emit("openPercentageChangeRequest", { percentage: setTo });
        },
      });
    },
    open() {
      animateXtoY({
        x: this.openPercentage,
        y: 1,
        time: 160,
        executable: ({ setTo }) => {
          this.$emit("openPercentageChangeRequest", { percentage: setTo });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";

.overlay_tray {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 10;
}
.overlay_tray__overlay {
  width: 100%;
  height: 100vh;
  position: absolute;
  background-color: $white;
  opacity: 0.5;
}
.overlay_tray__control {
  height: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.overlay_tray__touch_indication {
  width: 56px;
  height: 4px;
  background: $grey_mischka;
  border-radius: 2px;
}
.overlay_tray__content {
  background: $white;
  margin-top: 48px;
  height: calc(100vh - 48px);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid $grey_alabaster;
}
.overlay_tray__slot {
  height: 100%;
  overflow: scroll;
}
</style>
